<template>
  <div class="about">
    <!-- 页面标题 -->
    <!-- <div class="page-header">
      <h1>关于我们</h1>
      <p>了解我们的企业文化和团队</p>
    </div> -->

    <!-- 企业简介模块 -->
    <section class="about__intro">
      <div class="container">
        <div class="intro-content">
          <div class="intro-text">
            <h3 class="intro-title">{{ companyInfo.name }}</h3>
            <p class="intro-values">{{ companyInfo.values }}</p>
            <div class="features-grid">
              <div class="feature-item" v-for="(item, index) in companyInfo.features" :key="index">
                <div class="feature-icon">
                  <img :src="getIconUrl(item.icon)" :alt="item.title">
                </div>
                <h4 class="feature-title">{{ item.title }}</h4>
                <p class="feature-desc">{{ item.desc }}</p>
              </div>
            </div>
            <div class="stats-grid">
              <div class="stat-item" v-for="(item, index) in companyInfo.stats" :key="index">
                <div class="stat-icon">
                  <img :src="getIconUrl(item.icon)" :alt="item.label">
                </div>
                <div class="stat-info">
                  <div class="stat-value">
                    {{ item.value }}<span class="stat-unit" v-if="item.unit">{{ item.unit }}</span>
                  </div>
                  <p class="stat-label">{{ item.label }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="intro-image">
            <img :src="companyInfo.image" :alt="companyInfo.name">
          </div>
        </div>
      </div>
    </section>

    <!-- 底部使命愿景Banner -->
    <section class="about__mission">
      <div class="mission-banner">
        <!-- <div class="mission-header">
          <h2 class="mission-title">
            <span class="text-blue">科技</span>
            <span class="text-red">领航</span>
            <span class="text-blue">未来</span>
            <span class="text-white">服务成就生活</span>
            <span class="arrows">&gt;&gt;&gt;&gt;&gt;</span>
          </h2>
        </div>

        <div class="mission-circles">
          <div class="circle-item" v-for="(item, index) in companyInfo.missionVision" :key="index">
            <div class="circle-label">{{ item.label }}</div>
            <div class="circle-content">{{ item.content }}</div>
          </div>
        </div>

        <p class="mission-quote">不积跬步，无以至千里 不积小流，无以成江海</p> -->
      </div>
    </section>

    <!-- 发展历程时间线 -->
    <section class="about__timeline">
      <div class="container">
        <h2 class="section-title">发展历程</h2>
        <div class="timeline">
          <div
            v-for="(event, index) in timeline"
            :key="event.id"
            class="timeline-item"
            :class="{ 'timeline-item--left': index % 2 === 0, 'timeline-item--right': index % 2 === 1 }"
          >
            <div class="timeline-content">
              <div class="timeline-date">{{ event.date }}</div>
              <h3>{{ event.title }}</h3>
              <p v-if="event.description">{{ event.description }}</p>
            </div>
            <div class="timeline-dot"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心团队展示 -->
    <!-- <section class="about__team">
      <div class="container">
        <h2 class="section-title">核心团队</h2>
        <div class="team-list">
          <div
            v-for="member in team"
            :key="member.id"
            class="team-member"
          >
            <div class="member-image">
              <img :src="member.avatar" :alt="member.name">
            </div>
            <div class="member-info">
              <h3>{{ member.name }}</h3>
              <p class="member-position">{{ member.position }}</p>
              <p class="member-description">{{ member.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import { mockApi } from '../api/mock.js'

export default {
  name: 'About',
  components: {},
  data() {
    return {
      companyInfo: {
        name: '',
        description: '',
        mission: '',
        vision: '',
        values: '',
        image: '',
        features: [],
        stats: [],
        missionVision: []
      },
      timeline: [],
      team: []
    }
  },
  mounted() {
    this.fetchAboutData()
  },
  methods: {
    async fetchAboutData() {
      try {
        const response = await mockApi.getAboutData()
        if (response.code === 200) {
          this.companyInfo = response.data.companyInfo
          this.timeline = response.data.timeline
          this.team = response.data.team
        }
      } catch (error) {
        console.error('获取关于我们数据失败:', error)
      }
    },
    getIconUrl(iconName) {
      if (!iconName) return ''
      try {
        return require(`@/assets/about/icons/1/${iconName}`)
      } catch (e) {
        console.error('图标加载失败:', iconName, e)
        return ''
      }
    }
  }
}
</script>

<style scoped>
.about {
  padding: 0;
}

.page-header {
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  margin-bottom: 0;
}

.page-header h1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 10px;
}

.page-header p {
  font-size: 16px;
  color: #666;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 40px;
  color: #333;
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 80px;
  height: 4px;
  /* background: #007bff; */
  margin: 10px auto 0;
  border-radius: 2px;
}

/* 企业简介模块 */
.about__intro {
  padding: 40px 20px;
  margin-bottom: 20px;
}

.intro-content {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  align-items: center;
}

.intro-text {
  flex: 1;
  min-width: 300px;
}

.intro-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #333;
}

.intro-values {
  font-size: 15px;
  color: #4a90e2;
  margin-bottom: 30px;
  padding-bottom: 8px;
  border-bottom: 2px solid #4a90e2;
  display: inline-block;
  letter-spacing: 2px;
}

/* 特色项网格 */
.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.feature-item {
  text-align: center;
}

.feature-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.feature-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}

.feature-desc {
  font-size: 12px;
  line-height: 1.5;
  color: #666;
  margin: 0;
}

/* 数据卡片 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.stat-item {
  text-align: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.stat-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.stat-info {
  text-align: center;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #4a90e2;
  margin-bottom: 4px;
  line-height: 1.2;
}

.stat-unit {
  font-size: 14px;
  margin-left: 2px;
  font-weight: 500;
}

.stat-label {
  font-size: 13px;
  color: #666;
  margin: 0;
}

.intro-image {
  flex: 1;
  min-width: 300px;
}

.intro-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

/* ==================== 底部使命愿景Banner ==================== */
.about__mission {
  padding: 10px 20px;
  background: #f8f9fa;
}

.mission-banner {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  background-image: url('@/assets/about/icons/about_banner.png');
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  padding: 10px 40px;
  position: relative;
  overflow: hidden;
  min-height: 400px;
}

.mission-header {
  margin-bottom: 40px;
}

.mission-title {
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.text-blue {
  color: #1A73E8;
}

.text-red {
  color: #E53935;
  font-size: 36px;
  font-weight: 900;
}

.text-white {
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.arrows {
  color: #fff;
  font-size: 24px;
  margin-left: 12px;
}

/* 6个圆形元素 */
.mission-circles {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  margin: 40px 0;
}

.circle-item {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.circle-item:hover {
  transform: translateY(-4px);
}

.circle-label {
  font-size: 16px;
  font-weight: 700;
  color: #1A73E8;
  margin-bottom: 8px;
}

.circle-content {
  font-size: 12px;
  color: #333;
  text-align: center;
  line-height: 1.5;
}

.mission-quote {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
  margin: 20px 0 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 2px;
}

/* 发展历程时间线 */
.about__timeline {
  margin-bottom: 60px;
}

.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.timeline::after {
  content: '';
  position: absolute;
  width: 4px;
  background-color: #e0e0e0;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -2px;
  border-radius: 2px;
}

.timeline-item {
  position: relative;
  width: 50%;
  padding: 20px 40px;
  box-sizing: border-box;
}

.timeline-item--left {
  left: 0;
}

.timeline-item--right {
  left: 50%;
}

.timeline-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
}

.timeline-content::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 4px solid #007bff;
  top: 25px;
  border-radius: 50%;
  z-index: 1;
}

.timeline-item--left .timeline-content::after {
  right: -14px;
}

.timeline-item--right .timeline-content::after {
  left: -14px;
}

.timeline-date {
  font-size: 0.9rem;
  color: #007bff;
  font-weight: bold;
  margin-bottom: 10px;
}

.timeline-content h3 {
  font-size: 1.3rem;
  margin-bottom: 10px;
  color: #333;
}

.timeline-content p {
  font-size: 1rem;
  line-height: 1.5;
  color: #666;
  margin: 0;
}

.timeline-dot {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #007bff;
  border: 4px solid #fff;
  top: 30px;
  border-radius: 50%;
  z-index: 2;
}

.timeline-item--left .timeline-dot {
  right: -10px;
}

.timeline-item--right .timeline-dot {
  left: -10px;
}

/* 核心团队展示 */
.about__team {
  background: #f9f9f9;
  padding: 60px 0;
}

.team-list {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
}

.team-member {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  width: calc(33.333% - 20px);
  min-width: 280px;
  transition: transform 0.3s ease;
}

.team-member:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.member-image {
  height: 200px;
  overflow: hidden;
}

.member-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.team-member:hover .member-image img {
  transform: scale(1.1);
}

.member-info {
  padding: 20px;
}

.member-info h3 {
  font-size: 1.3rem;
  margin-bottom: 5px;
  color: #333;
}

.member-position {
  font-size: 0.9rem;
  color: #007bff;
  margin-bottom: 10px;
}

.member-description {
  font-size: 1rem;
  line-height: 1.5;
  color: #666;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }

  .intro-content {
    flex-direction: column;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .mission-title {
    font-size: 24px;
  }

  .text-red {
    font-size: 28px;
  }

  .mission-circles {
    gap: 16px;
  }

  .circle-item {
    width: 130px;
    height: 130px;
    padding: 16px;
  }

  .circle-label {
    font-size: 14px;
  }

  .circle-content {
    font-size: 11px;
  }

  .mission-quote {
    font-size: 14px;
  }

  .timeline::after {
    left: 31px;
  }

  .timeline-item {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

  .timeline-item--right {
    left: 0;
  }

  .timeline-content::after {
    left: -14px;
  }

  .timeline-dot {
    left: 21px;
  }

  .team-member {
    width: calc(50% - 15px);
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 1.8rem;
  }

  .intro-title {
    font-size: 22px;
  }

  .feature-icon {
    width: 56px;
    height: 56px;
  }

  .stat-value {
    font-size: 20px;
  }

  .circle-item {
    width: 110px;
    height: 110px;
    padding: 12px;
  }

  .team-member {
    width: 100%;
  }

  .timeline-item {
    padding-left: 60px;
  }
}
</style>
